/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Former goog.module ID: Blockly.IASTNodeLocation

/**
 * An AST node location interface.
 */
export interface IASTNodeLocation {}
